import Booking from '@/models/booking'
import BookingExtra from '@/models/booking-extra'

import { BookingsMutationTypes } from './bookings'

export enum PassengerExtrasActionTypes {}
export enum PassengerExtrasMutationTypes {}
export enum BookingExtrasGetters {
  GetBookingExtrasByBookingId = '[BookingExtras] GetBookingExtrasByBookingId',
}

export interface State {
  bookingExtraEntities: {
    [id: number]: BookingExtra
  }
  bookingExtraIds: number[]
}

const initialState: State = {
  bookingExtraEntities: {},
  bookingExtraIds: [],
}

export default {
  state: initialState,
  getters: {
    [BookingExtrasGetters.GetBookingExtrasByBookingId](
      state: State,
    ): (bookingId: number) => BookingExtra[] {
      return (bookingId: number) => {
        const ids = state.bookingExtraIds.filter(
          (id: number) =>
            state.bookingExtraEntities[id].bookingId === bookingId,
        )

        return ids.map((id: number) => state.bookingExtraEntities[id])
      }
    },
  },
  actions: {},
  mutations: {
    [BookingsMutationTypes.GetSuccess](state: State, booking: Booking) {
      const bookingExtraEntities: { [id: number]: BookingExtra } = {}
      const bookingExtraIds = state.bookingExtraIds

      booking.extras.forEach((bookingExtra: BookingExtra) => {
        if (state.bookingExtraIds.indexOf(bookingExtra.id) < 0) {
          bookingExtraIds.push(bookingExtra.id)
        }

        bookingExtraEntities[bookingExtra.id] = bookingExtra
      })

      state.bookingExtraEntities = {
        ...state.bookingExtraEntities,
        ...bookingExtraEntities,
      }

      state.bookingExtraIds = bookingExtraIds
    },
  },
}
